import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import { translate } from 'react-i18next';

import DataService from 'lib/DataService';

import Tooltip from 'components/Tooltip';
import { theme } from 'lib/styles';

import {
	Container,
	Details,
	Client,
	Specs,
	Spec,
	Footer,
	Actions,
	Master,
	Default,
} from './styles';

const Api = new DataService();

class Brochure extends React.Component {
	state = {
	  collectionLoading: false,
	  cloneLoading: false,
		removeLoading: false,
		generatingPdf: false,
		pdfUrl: false,
	}

	componentWillReceiveProps(nextProps) {
		this.setState({
			collectionLoading: false,
			cloneLoading: false,
			removeLoading: false,
			generatingPdf: false,
			pdfUrl: false,
		});
	}

	componentDidMount() {
	  this.mounted = true;
	}

	componentWillUnmount() {
	  this.mounted = false;
	}

	brochureCollectionToggle(brochureId) {
		const { collection } = this.props;
		const id = collection ? collection.id : '-';
		const brochures = collection ? collection.brochures : [];
		const data = collection ? collection.data : {};

		if (collection) {
			if (brochures.includes(brochureId)) {
				brochures.splice(brochures.findIndex(b => b === brochureId), 1);
			} else {
				brochures.push(brochureId);
			}

			Api.updateCollection({ id, brochures, data }).then(res => {
				if (res.result.collection) {
					this.props.collectionHandler(res.result.collection);
				}
			})
		} else {
			Api.createCollection([brochureId]).then(res => {
				if (res.result.collection) {
					this.props.collectionHandler(res.result.collection);
				}
			});
		}
	}

	generatePdf = () => {
		if(!this.state.generatingPdf) {
			this.setState({ generatingPdf: true, pdfUrl: '' });

			const brochureId = this.props.brochure.id;
			const quality = 'large';

			Api.getPdf({ brochureId, quality }).then(response => {
				if(this.mounted) {
					console.log(response);
					this.setState({ generatingPdf: false });

					if (response.result.pdf) {
						this.setState({ pdfUrl: response.result.pdf });

						if (this.props.brochure.type === 'default') {
							const building = { ...this.props.building };
							building.spaces.forEach((space, i) => {
								if (space.default_brochure === brochureId) {
									const item = { ...space };
									item.default_brochure_pdf = response.result.pdf;
									building.spaces[i] = item;
								}
							});
							this.props.updateBuildingHandler(building);
						}
					}
				}
			});
		}

	}

	openPdf = () => {
		window.open(this.state.pdfUrl);
		this.setState({ pdfUrl: false });
	}



	render() {
		const props = this.props;
		const { t, lng, brochure, brochureInCollection: inCollection } = props;
		const modifyTitle = `${t('building/Brochures/Modified')} ${brochure.modify_time} \n${t('building/Brochures/Created')} ${brochure.create_time}\n${t('brochure/PDF/generate/generated')} ${brochure.pdf_generated}`;

		return (
			<ThemeProvider theme={{ type: this.props.type, ...theme }}>
				<Container
					master={brochure.type === 'master'}
					new={brochure.new}
					style={props.style}>
					<Details to={`/${lng}/t/brochure/${brochure.id}/`}>
						<Client>
							{
								brochure.type === 'master' &&
								<Master>Master</Master>
							}
							{
								brochure.type === 'default' &&
								<Default>Default</Default>
							}
							{brochure.i18n[lng].name}
						</Client>
						{
							this.props.type === 'tile' &&
							<>
								<Specs>
									<Spec>{t('building/Brochures/Page', { count: brochure.content.pages })}</Spec>
								</Specs>
								<Specs>
									<Spec title={t('building/Brochures/Contacts')}>{brochure.contacts.map(user => `${user.firstName} ${user.lastName}`).join(', ')}</Spec>
								</Specs>
							</>
						}
						{
							this.props.type === 'list' && !this.props.fromCollection &&
							<>
								<Specs>
									<Spec>{brochure.authorName}</Spec>
									<Spec title={modifyTitle}>{brochure.modify_time}</Spec>
								</Specs>
								<Specs>
									<Spec>{t('brochure/PDF/generate/generated')}</Spec>
									<Spec title={modifyTitle}>{brochure.pdf_generated}</Spec>
								</Specs>
							</>
						}
					</Details>
					<Footer fromCollection={this.props.fromCollection}>
						{
							this.props.type === 'tile' &&
							<>
								<Specs>
									<Spec>{brochure.authorName}</Spec>
									<Spec title={modifyTitle}>{brochure.modify_time}</Spec>
								</Specs>
								<Specs>
									<Spec>{t('brochure/PDF/generate/generated')}</Spec>
									<Spec title={modifyTitle}>{brochure.pdf_generated}</Spec>
								</Specs>
							</>
						}
						<Actions>
							{
								props.canAddToCollection &&
								<Tooltip
									tooltip={t(inCollection ? t('collection/Remove from collection') : t('collection/Add to collection'))}
									spin={ this.state.collectionLoading }
									icon={ this.state.collectionLoading ? 'refresh' : 'star-full' }
									fill={ inCollection ? '#F5A623' : undefined }
									onClickHandler={e => {
										e.stopPropagation();
										e.preventDefault();

										if (!this.state.collectionLoading) {
											this.setState({ collectionLoading: true });
											this.brochureCollectionToggle(brochure.id);
										}
									}}
								/>
							}

							{
								props.canClone &&
								<Tooltip
									tooltip={t('building/Brochures/Copy')}
									spin={ this.state.cloneLoading }
									icon={ this.state.cloneLoading ? 'refresh' : 'duplicate' }
									onClickHandler={async e => {
										e.stopPropagation();
										e.preventDefault();

										if (!this.state.cloneLoading) {
											this.setState({ cloneLoading: true });

											props.cloneBrochureHandler((result) => {
												if (result === false) {
													this.setState({ cloneLoading: false });
												}
											}, brochure.id);
										}
									}}
								/>
							}

							{
								props.canShare &&
								<Tooltip
									tooltip={t(this.state.pdfUrl ? 'brochure/PDF/generate/open' : 'brochure/PDF/generate')}
									icon={this.state.generatingPdf ? 'refresh' : 'download-02'}
									spin={this.state.generatingPdf}
									onClickHandler={e => {
										e.stopPropagation();
										e.preventDefault();

										if(!this.state.generatingPdf) {
											if(this.state.pdfUrl) {
												this.openPdf();
											} else {
												this.generatePdf();
											}
										}
									}}
								/>
							}

							{
								brochure.content.pages > 0 &&
								<a href={`${props.baseUrl}/${lng}/e/${brochure.id}/${brochure.i18n[lng].slug}/`} target="_blank">
									<Tooltip
										tooltip={t('building/Brochures/View')}
										icon="view-show"
									/>
								</a>
							}
							{
								props.canRemove &&
								<Tooltip
									tooltip={t('building/Brochures/Remove')}
									spin={ this.state.removeLoading }
									icon={ this.state.removeLoading ? 'refresh' : 'trash' }
									danger
									onClickHandler={e => {
										e.stopPropagation();
										e.preventDefault();

										if (!this.state.removeLoading) {
											if (window.confirm(t('building/confirm/Delete'))) {
												this.setState({ removeLoading: true });
												props.deleteBrochureHandler(brochure.id)
											}
										}
									}}
								/>
							}
						</Actions>
					</Footer>
				</Container>
			</ThemeProvider>
		)
	}
}

Brochure.propTypes = {
	t: PropTypes.func,
	lng: PropTypes.string,
	type: PropTypes.string,
	baseUrl: PropTypes.string,
	fromCollection: PropTypes.bool,
	collection: PropTypes.any,
	collectionHandler: PropTypes.func,
	brochureInCollection: PropTypes.bool,
	canAddToCollection: PropTypes.bool,
	canShare: PropTypes.bool,
	canClone: PropTypes.bool,
	canRemove: PropTypes.bool,
	brochure: PropTypes.shape({
		id: PropTypes.string,
		name: PropTypes.string,
		content: PropTypes.shape({
			pages: PropTypes.number,
		}),
		author: PropTypes.string,
		modify_time: PropTypes.string,
		master: PropTypes.bool,
	}),
	deleteBrochureHandler: PropTypes.func,
	cloneBrochureHandler: PropTypes.func,
	shareBrochureHandler: PropTypes.func,
	style: PropTypes.object,
	building: PropTypes.object,
	updateBuildingHandler: PropTypes.func,
}

export default translate('translations')(Brochure)
